import { PAGE_TEMPLATES, COMPONENT_TEMPLATES } from "./utils/constants/templates";
import { environment } from "./environment";
import Standard from "./pages/magnolia/standard/Standard";
import ProductOverview from "./pages/magnolia/productOverview/ProductOverview";
import ProductDetail from "./pages/magnolia/productDetail/ProductDetail";
import ComponentFactoryItem from "./pages/magnolia/componentFactory/ComponentFactoryItem";
import Hero from "./components/magnolia/hero/Hero";
import HeroSlide from "./components/magnolia/hero/HeroSlide";
import Headline from "./components/magnolia/Headline";
import ImageComponent from "./components/magnolia/image/ImageComponent";
import Grid from "./components/magnolia/grid/Grid";
import InteractiveBlock from "./components/magnolia/interactiveBlock/InteractiveBlock";
import CardTeaser from "./components/magnolia/cardTeaser/CardTeaser";
import DynamicForm from "./components/magnolia/dynamicForm/DynamicForm";
import ComponentFactoryLink from "./components/magnolia/componentFactory/ComponentFactoryLink";
import CampaignFragmentItem from "./pages/magnolia/campaign/CampaignFragmentItem";
import ManagedCampaign from "./components/magnolia/managedCampaign/ManagedCampaign";
import MarketingForm from "./components/magnolia/marketingForm/MarketingForm";

export const componentMappings = {
    [PAGE_TEMPLATES.HOME]: Standard,
    [PAGE_TEMPLATES.STANDARD]: Standard,
    [PAGE_TEMPLATES.PRODUCT_OVERVIEW]: ProductOverview,
    [PAGE_TEMPLATES.PRODUCT_DETAIL]: ProductDetail,
    [COMPONENT_TEMPLATES.HERO]: Hero,
    [COMPONENT_TEMPLATES.HERO_SLIDE]: HeroSlide,
    [COMPONENT_TEMPLATES.HEADLINE]: Headline,
    [COMPONENT_TEMPLATES.IMAGE]: ImageComponent,
    [COMPONENT_TEMPLATES.GRID]: Grid,
    [COMPONENT_TEMPLATES.HTML]: InteractiveBlock,
    [COMPONENT_TEMPLATES.CARD_TEASER]: CardTeaser,
    // Mapped unconditionally, but the component is only offered in page/grid areas via the
    // demo's feature-dynamic-form decorations — the foundation knows no forms module.
    [COMPONENT_TEMPLATES.FORM]: DynamicForm,

    // Component Factory. Both ids come from the environment because the templates live in a
    // project light module rather than in this app: a project that renames them, or installs
    // no Component Factory at all, needs no change here. The first renders a factory item on
    // its own (what the Pages app previews), the second renders one embedded in a page.
    [environment.COMPONENT_FACTORY_PAGE_TEMPLATE]: ComponentFactoryItem,
    [environment.COMPONENT_FACTORY_LINK_TEMPLATE]: ComponentFactoryLink,
    [environment.COMPONENT_FACTORY_LINK_HEADLESS_TEMPLATE]: ComponentFactoryLink,

    // Campaign Manager and Marketing Automation — env-based ids for the same reason as the
    // Component Factory ones: the templates live in project light modules, not here.
    [environment.CAMPAIGN_FRAGMENT_PAGE_TEMPLATE]: CampaignFragmentItem,
    [environment.CAMPAIGN_COMPONENT_TEMPLATE]: ManagedCampaign,
    [environment.MARKETING_FORM_TEMPLATE]: MarketingForm,
    [environment.EMBEDDED_GRID_TEMPLATE]: Grid,
};
